import { ApiError } from "./ApiError";

export class ForbiddenException extends ApiError {

}